import { Component, inject, OnInit } from '@angular/core';
import { ChildrenOutletContexts, Router } from '@angular/router';
import { slideInOutAnimation } from '../../animations';
import { BookingService } from '@markant-platform/cartridge/data-access';
import { DialogService } from '@markant-platform/shared/dialog/feature';
import { BookingData, BookingState, UpgradeSuggestedStoragePrefix } from '@markant-platform/cartridge/model';
import { AuthenticatedUserService } from '@markant-platform/shared/user/data-access';
import { firstValueFrom, map } from 'rxjs';
import { VariantsStore } from './stores/variants/variants.store';

@Component({
  selector: 'markant-platform-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [slideInOutAnimation],
})
export class DashboardComponent implements OnInit {
  animations?: string;
  readonly store = inject(VariantsStore);

  constructor(
    private readonly contexts: ChildrenOutletContexts,
    private readonly bookingService: BookingService,
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly authenticatedUserService: AuthenticatedUserService
  ) {}

  async ngOnInit(): Promise<void> {
    this.animations = this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
    await this.store.getBookedVariants();
    const userBookings = await firstValueFrom(
      this.bookingService
        .getBookingsForUser([
          BookingState.BOOKED,
          BookingState.ACCEPTED,
          BookingState.PENDING,
          BookingState.TO_BE_CANCELLED,
        ])
        .pipe(map(({ result }) => result))
    );
    await this.displaySuggestUpgradePopup(userBookings);
  }

  private async displaySuggestUpgradePopup(userBookings: BookingData[]): Promise<void> {
    const { userId } = this.authenticatedUserService;

    const services = await this.bookingService.getServicesToShowUpgradeSuggestedPopup(userId as string, userBookings);
    const nextPopup = services?.shift();

    if (!nextPopup) {
      return;
    }

    localStorage.setItem(`${UpgradeSuggestedStoragePrefix}-${nextPopup.cartridgeId}`, nextPopup.cartridgeId);

    this.dialogService.showApproveDialogWithTransloco(
      'cartridge.management.suggestUpgrade.popup.headline',
      'cartridge.management.suggestUpgrade.popup.text',
      async () => {
        await this.router.navigate([`/cartridge/catalog/${nextPopup.cartridgeId}/detail`]);
      },
      'cartridge.management.suggestUpgrade.popup.upgradeNowButton',
      'cartridge.management.suggestUpgrade.popup.upgradeLaterButton',
      { serviceName: nextPopup.cartridgeName },
      () => {
        this.displaySuggestUpgradePopup(userBookings);
      }
    );
  }
}
